import { Pipe, PipeTransform } from "@angular/core";
import { AlLocation } from "@al/core";
import { AlNavigationService } from "@al/ng-navigation-components";
import { AlArtifactsDefinition } from "../types/al-artifacts-definition";

@Pipe({ name: 'alSetupLinkURL' })
export class AlSetupLinkURLPipe implements PipeTransform {

    constructor(public navigation: AlNavigationService) { }

    transform(cardItem: AlArtifactsDefinition, accountId: string, page: 'search'|'schedules' = 'search'): string {

        let locTypeId: string = AlLocation.SearchUI;
        let path: string = '';
        let queryParams: { [p: string]: string } = { };
        if ( page === 'search' ) {
            path = `/#/search/expert/${accountId}`;
            queryParams['uuid'] = cardItem.properties.artifactData?.result_id as string;
        } else {
            path = `/#/saved-searches/${accountId}`;
            queryParams['scheduledSearchId'] = cardItem.properties.scheduleId as string;
        }

        const url = this.navigation.resolveURL({ locTypeId: locTypeId, path: path }, queryParams);

        return url;
    }
}
